import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import InfoTooltip from "../../../common/components/functional/InfoTooltip/InfoTooltip";

type Props = {
  amountFulfilled: number;
  amountOrdered: number;
  originalAmountOrdered?: number;
};

export const OrderFulfillmentInfo = ({
  amountFulfilled,
  amountOrdered,
  originalAmountOrdered,
}: Props) => {
  const { t } = useTranslation("order");
  const showOriginalAmountInfo =
    originalAmountOrdered !== undefined &&
    originalAmountOrdered !== amountOrdered;

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" gap="6px">
      <Typography fontSize="14px" pl="4px">
        {`${amountFulfilled}/${amountOrdered}`}
      </Typography>
      {showOriginalAmountInfo ? (
        <InfoTooltip
          variant="text"
          title={t("originalOrderedAmountInfo", {
            count: originalAmountOrdered,
          })}
        />
      ) : null}
    </Box>
  );
};
